import {Component, OnInit} from '@angular/core';

declare var $:any;

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class ListComponent implements OnInit {

	// Line Chart
	public lineChartData:Array<any> = [
	    {data: [10, 18, 20, 24, 28, 24, 30], label: 'Series A', fill: false, lineTension: 0},
	    {data: [10, 20, 25, 22, 26, 32, 26], label: 'Series B', fill: false, lineTension: 0},
  	];
  	public lineChartLabels:Array<any> = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
  	public lineChartOptions:any = {
	    responsive: true
  	};
	public lineChartColors:Array<any> = [
	    {
	      	backgroundColor: 'transparent',
	      	borderColor: '#ff6384',
	      	pointBackgroundColor: '#ff6384',
	      	pointBorderColor: '#fff',
	      	pointHoverBackgroundColor: '#fff',
	      	pointHoverBorderColor: '#ff6384'
	    },
	    {
	      	backgroundColor: 'transparent',
	      	borderColor: '#36a2eb',
	      	pointBackgroundColor: '#36a2eb',
	      	pointBorderColor: '#fff',
	      	pointHoverBackgroundColor: '#fff',
	      	pointHoverBorderColor: '#36a2eb'
	    },
  	];
  	public lineChartLegend:boolean = true;
  	public lineChartType:string = 'line';


  	public doughnutChartLabels:string[] = ['Download Sales', 'In-Store Sales', 'Mail-Order Sales'];
  	public doughnutChartData:number[] = [350, 450, 100];
  	public doughnutChartType:string = 'doughnut';
    public doughnutChartOptions:any ={
      legend: {
        align: 'center',
        position: 'right'
      },
      responsive: true,
    };

  constructor() {

  }

  ngOnInit() {

  }

  public chartClicked(e:any):void {
    // console.log(e);
  }
 
  public chartHovered(e:any):void {
    // console.log(e);
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/statistic/list/list.component.ts